module.exports = __webpack_public_path__ + "a65375c9a47877f952ff94699684a984.svg";